import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'ut/IMG_20210117_134742-PANO.jpg' satisfies MediaPath
const a = 'ut/PXL_20210309_010705520.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: '2021',
	name: '2021',
	excerpt: 'Slow light',
	tags: ['photography'],
	cover,
	order: 160,
}

export default function Year2021() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2021 — panorama' },
					{ src: a, alt: '2021' },
				]}
			/>
		</>
	)
}
